import {createReducer} from '@reduxjs/toolkit';

import {adapter, initialState} from './state';
import {clearAllAction, clearErrorsAction,} from './actions';
import {getAllCustomers, getCustomerById,} from '../customers';

export const reducer = createReducer(initialState, builder =>
    builder
        /** HANDLE ACTION ====================================== */
        .addCase(getAllCustomers.pending, state => {
            return {...state, isFetching: true};
        })
        .addCase(getAllCustomers.fulfilled, (state, action) => {
            const {holidays} = action.payload.results;
            return adapter.setAll({...state, isFetching: false}, holidays);
        })
        .addCase(getAllCustomers.rejected, state => {
            return {...state, isFetching: false};
        })

        .addCase(getCustomerById.pending, state => {
            return {...state, isFetching: true};
        })
        .addCase(getCustomerById.fulfilled, (state, action) => {
            const {holidays, customer} = action.payload.results;
            const storedIds = adapter.getSelectors().selectAll(state)
                .filter((holiday) => holiday.siteId === customer.company.siteId)
                .map((holiday) => holiday.id);
            // Remove-then-add, not upsert: upsertMany keeps existing ids in place, so a new holiday
            // would land last and break first-match lookups that rely on the API's order.
            const newState = adapter.removeMany({...state, isFetching: false}, storedIds);
            return adapter.addMany(newState, holidays);
        })
        .addCase(getCustomerById.rejected, state => {
            return {...state, isFetching: false};
        })


        /** HANDLE NON-API ACTIONS ====================================== */
        .addCase(clearAllAction.fulfilled, () => adapter.removeAll({...initialState}))
        .addCase(clearErrorsAction.fulfilled, state => ({...state, errorMessage: undefined}))
);
